import React from 'react';
import styles from '../OrderList.module.css';

function SelectedItemSection({
    selectedItems,
    setChangeStatusOpen,
    setAssignOpen,
    SteadFastEntry,
    SteadFastLoading,
    DownloadCSV,
    handlePrintInvoice,
    handlePrintSticker,
    handleBulkDelete,
    hideAssign = false,
    onAiCall = null,
}) {
    if (selectedItems.length === 0) return null;

    return (
        <div className={styles['shopify-selected-actions']}>
            <div className={styles['selected-info']}>
                <span className={styles['selected-count']}>
                    {selectedItems.length} item
                    {selectedItems.length !== 1 ? 's' : ''} selected
                </span>
            </div>
            <div className={styles['action-buttons']}>
                {setChangeStatusOpen && (
                    <button
                        className={styles['action-btn']}
                        onClick={() => setChangeStatusOpen(true)}
                    >
                        Change Status
                    </button>
                )}
                <button
                    className={styles['action-btn']}
                    onClick={handlePrintInvoice}
                >
                    Print Invoice
                </button>
                <button
                    className={styles['action-btn']}
                    onClick={handlePrintSticker}
                >
                    Print Sticker
                </button>
                {SteadFastEntry && (
                    <button
                        className={styles['action-btn']}
                        onClick={SteadFastEntry}
                        disabled={SteadFastLoading}
                    >
                        {SteadFastLoading ? 'Loading...' : 'SteadFast Entry'}
                    </button>
                )}
                {!hideAssign && (
                    <button
                        className={styles['action-btn']}
                        onClick={() => setAssignOpen(true)}
                    >
                        Assign Order
                    </button>
                )}
                {onAiCall && (
                    <button className={styles['action-btn']} onClick={onAiCall} title="The AI calls each selected customer to confirm the order">
                        📞 AI Call
                    </button>
                )}
                <button className={styles['action-btn']} onClick={DownloadCSV}>
                    Download CSV
                </button>
                {handleBulkDelete && (
                    <button
                        className={styles['action-btn-danger']}
                        onClick={handleBulkDelete}
                    >
                        Delete Order
                    </button>
                )}
            </div>
        </div>
    );
}

export default SelectedItemSection;
